export const traverseTree = (messages, callback) => {
  messages.forEach(message => {
    if (message) {
      callback(message);
    }
    if (message.children && message.children.length > 0) {
      traverseTree(message.children, callback);
    }
  });
};
